import axios from "./general/HttpClient";
import { SDImage } from "./images/ImagesStore";

export const BrowseThemes = () => {
    return axios.get("/api/themes/browse");
};

export const GenerateThemes = (_prompt) => {
    return axios.get("/api/themes/generateThemes", { params: { prompt: _prompt } });
};

export const CreateTheme = (newThemeName) => {
    return axios.post("/api/themes/create", { name: newThemeName });
};

export const GetTheme = (id) => {
    return axios.get(`/api/themes/${id}`);
};

export const DeleteTheme = (selectedTheme) => {
    if (selectedTheme.id) {
        return axios.delete("/api/themes/delete", { params: { id: selectedTheme.id } });
    }
    return Promise.resolve();
};

export const GenerateThemeImage = (themeID, setMessage) => {
    let now = new Date();
    const _messages = [] as string[];
    setMessage("Starting generation...");
    return new Promise((resolve, reject) => {
        var eventSource = new EventSource("/api/themes/generateImage?id=" + themeID, { withCredentials: true });

        eventSource.onmessage = (event) => {
            console.log(event.data);

            if (event.data.indexOf("image") == 0) {
                setMessage("Generating Theme Image...");
            }

            if (event.data.indexOf("done") == 0) {
                setMessage("Finished in " + (new Date().getTime() - now.getTime()) / 1000 + "s");
                eventSource.close();
                resolve(true);
            }
        };
    });
};

export const GenerateThemeBorder = (themeID, setMessage) => {
    let now = new Date();
    const _messages = [] as string[];
    setMessage("Starting generation...");
    return new Promise((resolve, reject) => {
        var eventSource = new EventSource("/api/themes/GenerateBorder?id=" + themeID, { withCredentials: true });

        eventSource.onmessage = (event) => {
            console.log(event.data);

            if (event.data.indexOf("image") == 0) {
                setMessage("Generating Theme Border...");
            }

            if (event.data.indexOf("done") == 0) {
                setMessage("Finished in " + (new Date().getTime() - now.getTime()) / 1000 + "s");
                eventSource.close();
                resolve(true);
            }
        };
    });
};

export interface Theme {
    id: number;
    name: string;
    borderImageID: number | null;
    borderImage: SDImage;
    themeImageID: number | null;
    themeImage: SDImage;
}
